/*
 * Generic Accordion functionality for the site.
 */
var AccordionController = (function ($) {
    
    var win, doc;

    function ready() {
        win = $(window);
        doc = $(document.body);
        doc.on("keypress click", '[data-acc-toggle]', toggleSpecificAccordion);
        doc.on("click", '.acc-content a, .acc-content input, .acc-content button', onAccordionContentLinkClick);
        wrapTableBodies();
        $(BreakpointController).on('crossBreakpoint', onCrossBreakpoint);

        $('.wp-FAQ__item').each(function (index, element) {
            var el = new Accordion($(element));
            el.toggleContent();
        });
    }
    
    function onCrossBreakpoint() {
        if (BreakpointController.isMobile()) {
            wrapTableBodies();
        }
    }
    
    /*
     * Wrap the table bodies in a div on mobile to allow the accordions to work.
     */
    function wrapTableBodies() {
        if (BreakpointController.isMobile()) {
            $(".acc-content").each(function () {
                var content = $(this);
                content.addClass('mobile');
            });
        }
    }
  
    // Toggle a specific accordion by looking for it's content element.
    function toggleSpecificAccordion(e) {
        if (e.type === "keypress") {
            if (e.which === 13) {
                e.preventDefault();
            }
            else {
                return;
            }
        }
        else {
            e.preventDefault();
        }
        var toggle = $(e.currentTarget),
            toggleIcon,
            disabledSetting = toggle.attr("data-acc-disabled") || "",
            isDesktopDisabled = /(^|\s+)desktop($|\s+)/gi.test(disabledSetting),
            isMobileDisabled = /(^|\s+)mobile($|\s+)/gi.test(disabledSetting),
            content = $(toggle.attr('data-acc-toggle')),
            isMobile = BreakpointController.isMobile();
            
        if (!toggle.hasClass('acc-toggle-icon')) {
          toggleIcon = toggle.find('.acc-toggle-icon');
        }
        
        if (!isMobile && isDesktopDisabled) {
          return;
        }
        if (isMobile && isMobileDisabled) {
          return;
        }
        if (content.length > 0) {
            var faq = content.closest('.faq');
            if (toggleIcon.hasClass('open')) {
                toggleIcon.removeClass('fa-minus open').addClass('fa-plus');
                faq.removeClass('open');
                slideUp(content);
            }
            else {
                toggleIcon.removeClass('fa-plus').addClass('fa-minus open');
                faq.addClass('open');
                slideDown(content);
                TableController.fixDataTableHeights();
            }
        }
    }
    
    // Stop propagation on links inside the content to prevent the accordion from toggling around unexpectedly.
    function onAccordionContentLinkClick(e) {
        e.stopPropagation();
    }
    
    function slideUp(content, callback) {
        content.stop(true, true).slideUp(250, 'easeInOutExpo', callback);
    }
    function slideDown(content, callback) {
        content.stop(true, true).slideDown(250, 'easeInOutExpo', callback);
    }

    function Accordion($el) {
        this.$el = $el || null;
        this.isExperienceEditor = $('.is-experience-editor').length;

        if (this.$el.length) {
            this.setupDefaults();

            if (!this.isExperienceEditor) {
                this.addListeners();

            } else {
                this.initExpEd();
            }
        }
    };

    Accordion.prototype.setupDefaults = function () {
        this.dom = {
            $trigger: this.$el.find('.js-accordion-trigger'),
            $icon: this.$el.find('.js-accordion-trigger').find('.fa'),
            $content: this.$el.find('.js-accordion-content')
        }
    };

    Accordion.prototype.addListeners = function () {
        this.dom.$trigger.on('keypress', this.onTriggerClick.bind(this));
    };

    Accordion.prototype.onTriggerClick = function (e) {
        e.stopPropagation();
        e.preventDefault();

        this.$el.toggleClass('active');
        this.toggleContent();
    };

    Accordion.prototype.initExpEd = function () {
        this.$el.toggleClass('active');
        this.dom.$content.slideDown();
    };

    Accordion.prototype.toggleContent = function () {
        if (!this.$el.hasClass('active')) {
            this.dom.$icon.attr('class', 'fa fa-plus');
            this.dom.$content.stop(true, true).slideUp(250, 'easeInOutExpo');
        } else {
            this.dom.$icon.attr('class', 'fa fa-minus');
            this.dom.$content.stop(true, true).slideDown(250, 'easeInOutExpo');
        }

        setTimeout(function () {
            $(window).resize();
        }, 250);
    };

    
    $(ready);
    
  return {};

})(jQuery);